import React from "react"
import { BaseVisualizationConfigureModal } from "../../../Modals/BaseVisualizationConfigureModal"
import { MobergColumn, MobergDropdown, MobergInputLabel, MobergNumberInput } from "../../../../../../../../Moberg"
import { CPPOPT_WINDOW_TIME_PRESETS } from "../../../../../../../../Managers/VisualizationManager/Viewport/Components/XAxis"
import { cppOptPlotConfigsAtom } from "../../../../Atoms/CPPOpt"
import { useEditWindow } from "../../../Modals/useEditWindow"
import { CPPOptPlotJSON } from "../../../../Types/CPPOptPlot"
import { validatePRxThreshold } from "../validation"
import { Analytic } from "../../../../Types/AnalysisDetails"
import { useTraceOptions } from "../../../Modals/EditAnalysis/useTraceOptions"
import { equalsTraceOptionOrString } from "../../../../utils"

type CPPOptPlotConfigureModalProps = {
	windowId: string
	layoutId: string
}

export const CPPOptPlotConfigureModal = (props: CPPOptPlotConfigureModalProps) => {
	const atom = cppOptPlotConfigsAtom({windowId: props.windowId, layoutId: props.layoutId})
	const traceOptions = useTraceOptions()
	const { editedConfig, saveChanges, updateProperty } = useEditWindow<CPPOptPlotJSON>({ recoilState: atom, windowId: props.windowId, layoutId: props.layoutId })

	return (
		<BaseVisualizationConfigureModal layoutId={props.layoutId} windowId={props.windowId} title={"Configure CPPOpt"} saveChanges={saveChanges}>
			<div style={{ height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
				<MobergColumn gap="32px" verticalAlign="center" expand={true}>
					<MobergColumn gap="32px">
						<MobergColumn expand={false} gap="8px">
							<MobergInputLabel text={"Initial window size"} />
							<MobergDropdown
								selectedValue={editedConfig?.viewDuration}
								onChange={value => updateProperty("viewDuration", parseInt(value as string))}
								options={CPPOPT_WINDOW_TIME_PRESETS
									.filter(preset => preset.label !== "Page Size")
									.map(preset => ({ label: preset.label, value: preset.time }))}
							/>
						</MobergColumn>

						<MobergColumn expand={false} gap="8px">
							<MobergInputLabel text={"ABP modality"} />
							<MobergDropdown
								selectedValue={editedConfig?.abpModality}
								onChange={modality => updateProperty("abpModality", modality.rawDataKey)}
								options={traceOptions}
								equals={equalsTraceOptionOrString}
							/>
						</MobergColumn>
						
						<MobergColumn expand={false} gap="8px">
							<MobergInputLabel text={"ICP modality"} />
							<MobergDropdown
								selectedValue={editedConfig?.icpModality}
								onChange={modality => updateProperty("icpModality", modality.rawDataKey)}
								options={traceOptions}
								equals={equalsTraceOptionOrString}
							/>
						</MobergColumn>

						<MobergColumn expand={false} gap="8px">
							<MobergInputLabel text={"PRx threshold of autoregulation"} />
							<MobergNumberInput
								defaultValue={0.25}
								validationFunction={validatePRxThreshold}
								value={editedConfig?.prxThreshold}
								onChange={threshold => updateProperty("prxThreshold", threshold)}
							/>
						</MobergColumn>

						<MobergColumn expand={false} gap="8px">
							<MobergInputLabel text={"CPPopt Algorithm"} />
							<MobergDropdown
								selectedValue={editedConfig?.cppoptAlgorithm}
								onChange={modality => updateProperty("cppoptAlgorithm", modality)}
								options={[
									{label: "Single-window", value: Analytic.CPPOpt},
									{label: "Multi-window", value: Analytic.CPPOpt_FLEX},
								]}
							/>
						</MobergColumn>
					</MobergColumn>
				</MobergColumn>
			</div>
		</BaseVisualizationConfigureModal>
	)
}
